import type { FC } from "react";
import styled from "@emotion/styled";
import { RAG_LOADING_MESSAGES } from "../../constants/rag-loading-messages";
import { useSequentialTransition } from "../../hooks/use-sequential-transition";
import { colors, transitions } from "../design-tokens";

type LoadingIteratorProps = {
  messages?: string[];
  interval?: number;
};

const LoadingText = styled.p<{ isChanging: boolean; pulseDuration: number }>`
  color: ${colors.muted};
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  ${transitions.fadeSlide()}
  ${props => !props.isChanging && transitions.pulse(props.pulseDuration)}
  opacity: ${props => props.isChanging ? 0 : 1};
  transform: translateY(${props => props.isChanging ? 4 : 0}px);
`;

export const LoadingIterator: FC<LoadingIteratorProps> = ({
  messages = RAG_LOADING_MESSAGES,
  interval = 1500,
}) => {
  const { currentItem, isChanging, pulseDuration } = useSequentialTransition(messages, interval);

  return (
    <LoadingText isChanging={isChanging} pulseDuration={pulseDuration}>
      {currentItem}
    </LoadingText>
  );
};
